module.exports = __webpack_public_path__ + "media/images/application/template/logos/icsa-8fcfb1cfcb649097b480d642b77f0280.png";